module.exports = __webpack_public_path__ + "img/find-car-1.1fdba96a.png";